import React from "react";
import LoginPage from "../../components/Login/LoginPage";
import {
  FiBarChart2,
  FiBox,
  FiShield,
  FiUsers,
} from "react-icons/fi";

const FEATURES = [
  { icon: FiBox, title: "Inventory & Stock" },
  { icon: FiBarChart2, title: "Sales & Reports" },
  { icon: FiUsers, title: "Team Access" },
  { icon: FiShield, title: "Secure Sessions" },
];

const Auth = () => {
  return (
    <div className="flex h-screen max-h-screen w-full flex-col overflow-hidden font-quicksand lg:flex-row">
      {/* ── Left brand panel (side-menu teal gradient) ── */}
      <aside className="relative hidden lg:flex lg:w-1/2 shrink-0 flex-col overflow-hidden text-white border-r border-white/10 shadow-[4px_0_24px_rgba(0,0,0,0.08)]">
        <div
          aria-hidden
          className="absolute inset-0 bg-gradient-to-b from-main via-[#0f4849] to-[#0a3d3e]"
        />
        <div
          aria-hidden
          className="absolute inset-0 opacity-[0.35]"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)",
            backgroundSize: "48px 48px",
          }}
        />
        <div
          aria-hidden
          className="absolute -left-20 top-1/3 h-80 w-80 rounded-full bg-sec2/10 blur-[100px]"
        />

        <div className="relative z-10 flex flex-1 min-h-0 flex-col justify-center px-14 xl:px-16 py-10">
          <div className="flex items-center gap-4">
            <div className="shrink-0 rounded-2xl bg-white p-2.5 shadow-lg">
              <img
                src="/logo.svg"
                alt="Irshad Carton Dealer"
                className="h-14 w-14 object-contain"
              />
            </div>
            <div>
              <p className="text-lg font-bold tracking-wide">IRSHAD CARTON DEALER</p>
              <p className="text-sm text-white/55">Est. 1998 · Carton & ERP</p>
            </div>
          </div>

          <h1 className="mt-10 text-[2rem] xl:text-[2.25rem] font-bold leading-tight tracking-tight">
            Manage Your Business
            <span className="block text-[#f3df9f]">Smarter</span>
          </h1>
          <p className="mt-4 max-w-md text-[15px] leading-relaxed text-white/60">
            A complete ERP platform for inventory, sales, vendors, customers,
            and financial reporting — all in one place.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-3 max-w-lg">
            {FEATURES.map(({ icon: Icon, title }) => (
              <div
                key={title}
                className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.06] px-4 py-3.5 backdrop-blur-sm"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sec2/20 text-[#f3df9f]">
                  <Icon size={17} aria-hidden />
                </span>
                <span className="text-sm font-semibold text-white/90 leading-tight">
                  {title}
                </span>
              </div>
            ))}
          </div>
        </div>

        <p className="relative z-10 shrink-0 border-t border-white/10 bg-black/10 px-14 xl:px-16 py-4 text-xs text-white/40">
          Business Management Platform
        </p>
      </aside>

      {/* ── Mobile header ── */}
      <div className="lg:hidden shrink-0 bg-gradient-to-b from-main to-[#0a3d3e] px-6 py-8 flex items-center gap-3 border-b border-white/10">
        <div className="shrink-0 rounded-xl bg-white p-2 shadow-lg">
          <img
            src="/logo.svg"
            alt="Irshad Carton Dealer"
            className="h-11 w-11 object-contain"
          />
        </div>
        <div className="text-white">
          <p className="text-sm font-bold tracking-wide">IRSHAD CARTON DEALER</p>
          <p className="text-xs text-white/55">Est. 1998 · Carton & ERP</p>
        </div>
      </div>

      {/* ── Right login panel ── */}
      <main className="relative flex flex-1 min-h-0 min-w-0 items-center justify-center bg-page px-5 py-8 sm:px-8">
        <LoginPage />
      </main>
    </div>
  );
};

export default Auth;
